import React from "react";
import { Link } from "react-router-dom";
import footerBg from "../../images/bg/footer-bg.png";
import emailIcon from "../../images/icon/email-icon.svg";
import locationIcon from "../../images/icon/location-icon.svg";
import { organisation } from "../../data/clearith";
import BrandMark from "../Clearith/BrandMark";

const Footer: React.FC = () => (
  <footer
    className="footer footer-style-one cl-footer bg_img"
    style={{ backgroundImage: "url(" + footerBg + ")" }}
  >
    <div className="container">
      <div className="cl-footer__top">
        <div className="cl-footer__identity">
          <BrandMark />
          <p>
            Des parcours de formation structurés pour développer et certifier
            vos compétences professionnelles.
          </p>
          <a href={"mailto:" + organisation.email}>
            <img src={emailIcon} alt="" aria-hidden="true" />
            {organisation.email}
          </a>
        </div>
        <div className="cl-footer__nav">
          <div>
            <span>Navigation</span>
            <Link to="/">Accueil</Link>
            <Link to="/a-propos">À propos</Link>
            <Link to="/formations">Nos formations</Link>
            <Link to="/methode-pedagogique">Méthode pédagogique</Link>
          </div>
          <div>
            <span>Votre parcours</span>
            <Link to="/formations/vtest-business-english-4-skills">
              VTest Business English
            </Link>
            <Link to="/financement">Financement</Link>
            <Link to="/accessibilite">Accessibilité</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <div>
            <span>Informations</span>
            <Link to="/mentions-legales">Mentions légales</Link>
            <Link to="/politique-confidentialite">
              Politique de confidentialité
            </Link>
            <p>
              <a
                  href="/certificat-qualiopi-clearith.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                Qualiopi · Actions de formation
              </a>
            </p>
            <p>NDA {organisation.activityDeclaration}</p>
          </div>
        </div>
      </div>

      <div className="cl-footer__legal">
        <p>{organisation.legalNotice}</p>
      </div>

      <div className="cl-footer__bottom">
        <div className="cl-footer__address">
          <img src={locationIcon} alt="" aria-hidden="true" />
          <span>{organisation.address}</span>
        </div>
        <p>
          © {new Date().getFullYear()} CLEARITH · Organisme de formation
          professionnelle
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
